import QueryString from "query-string";

export default function getQueryParameters(): {} {
    // Get the location hash
    let searchString: string = location.search;
    if (!location.search && location.hash && location.hash.includes("?")) {
        searchString = location.hash.split("?")[1];
    }

    if (!searchString) {
        return {};
    }

    return QueryString.parse(searchString);
}



// WEBPACK FOOTER //
// ./src/utils/getQueryParameters.ts